import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: ['./select-dialog.component.scss']
})
export class SelectDialogComponent implements OnInit {

  label: string;
  values: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SelectDialogComponent>) { }

  ngOnInit() {
    this.label = this.data.label;
    this.values = this.data.values;
  }

  selectValue(value) {
    this.dialogRef.close(value)
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/select-dialog.component.ts